import * as React from "react";
import { useRecordContext } from "react-admin";
import { useFormState } from "react-final-form";
import { Typography, Paper, List, ListItem, ListItemText, Link } from "@material-ui/core";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

export function AssetPathsTab() {
  const record = useRecordContext();
  const formState = useFormState();
  const slug = record?.slug || formState?.values?.slug || "{slug}";

  const assetPaths = [
    {
      label: "Thumbnail Image",
      path: `programs/${slug}.jpg`,
      description: "Main program thumbnail displayed in lists and cards",
      s3Url: "https://us-east-1.console.aws.amazon.com/s3/buckets/steezy-assets?region=us-east-1&prefix=programs%2F&showversions=false&tab=objects",
    },
    {
      label: "Preview Video",
      path: `program-previews/${slug}.mp4`,
      description: "Short preview video shown on program detail page",
      s3Url: "https://us-east-1.console.aws.amazon.com/s3/buckets/steezy?region=us-east-1&prefix=program-previews%2F&showversions=false&tab=objects",
    },
    {
      label: "Instructor Image",
      path: `program-instructors/${slug}.jpg`,
      description: "Instructor photo displayed on the program page",
      s3Url: "https://us-east-1.console.aws.amazon.com/s3/buckets/steezy-assets?region=us-east-1&prefix=program-instructors%2F&showversions=false&tab=objects",
    },
    {
      label: "Title SVG",
      path: `program-titles/${slug}.svg`,
      description: "Stylized title graphic for the program header",
      s3Url: "https://us-east-1.console.aws.amazon.com/s3/buckets/steezy-assets?region=us-east-1&prefix=program-titles%2F&showversions=false&tab=objects",
    },
  ];

  return (
    <div style={{ maxWidth: 700 }}>
      <Typography variant="h6" gutterBottom>
        Expected S3 Asset Paths
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        The content team uploads assets directly to S3. Below are the expected
        paths for this program&apos;s assets.
      </Typography>
      <Typography variant="body2" color="error" gutterBottom>
        <strong>Important:</strong> All asset files must be named using the program&apos;s slug
        (e.g. <code>{slug}.jpg</code>, <code>{slug}.mp4</code>). Incorrect naming will cause
        assets to not display. Do not rename the slug after assets have been uploaded.
      </Typography>
      <Paper variant="outlined" style={{ marginTop: 16 }}>
        <List>
          {assetPaths.map((asset) => (
            <ListItem key={asset.label} divider>
              <ListItemText
                primary={asset.label}
                secondary={
                  <>
                    <code style={{ fontWeight: "bold" }}>{asset.path}</code>
                    <br />
                    {asset.description}
                    <br />
                    <Link
                      href={asset.s3Url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: "inline-flex", alignItems: "center", gap: 4, marginTop: 4 }}
                    >
                      Open S3 Bucket <OpenInNewIcon style={{ fontSize: 14 }} />
                    </Link>
                  </>
                }
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </div>
  );
}
